import ReactMarkdown from "react-markdown"
import cn from "@/v2-ui/utils/utils.cn"

export type MarkdownProps = {
  className?: string
  /** Markdown source; raw HTML is never rendered (react-markdown default). */
  children: string
}

/**
 * Compact markdown renderer tuned for chat/assistant surfaces: small
 * type, tight spacing, styled lists and inline code (see markdown.css).
 */
function Markdown(props: MarkdownProps) {
  const { className, children } = props
  return (
    <div className={cn("markdown-chat", className)}>
      <ReactMarkdown>{children}</ReactMarkdown>
    </div>
  )
}

export default Markdown
